module.exports = __webpack_public_path__ + "assets/img/头像.dba98711.png";